import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { COESecuredReportService } from "src/app/services/autopac-reports/coe-secured-report.service";

@Component({
  selector: "coe-secured-report",
  templateUrl: "./coe-secured-report.component.html",
  styleUrls: ["./coe-secured-report.component.css"],
})
export class COESecuredReportComponent implements OnInit {
  faPrint = faPrint;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private COESecuredReportService: COESecuredReportService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.COESecuredReportService.CoeSecured(searchData).subscribe({
      next: (response) => {
        if (this.getFieldValue("Format") == "pdf") {
          window.open(response.body.Name, "_blank");
        } else if (this.getFieldValue("Format") == "excel") {
          window.open(response.body.Value, "_blank");
        } else if (this.getFieldValue("Format") == "both") {
          window.open(response.body.Value, "_blank");
          window.open(response.body.Name, "_blank");
        }
      },
      error: (error) => {
        console.log(error);
        this.handleError("Error getting data", error);
      },
    });
  }

  private populateSearchBody(): any {
    return {};
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
